import React from 'react';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import CatchImage from '../../images/catch/catch_way.jpg';
import CatchImage2x from '../../images/catch/catch_way@2x.jpg';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';

const MethodPage: React.FC = () => {
  useTitle('Ton Bébé | 精子提供の方法');
  useMetaDescription('精子提供の方法を解説。シリンジ法とタイミング法、それぞれの特徴やおすすめの検査・提供キットについてTon Bébéがご紹介します。');

  return (
    <>
      <header>
        <TopNav />
        <div className="catch sub">
          <img
            src={ CatchImage }
            srcSet={ `${ CatchImage } 1x, ${ CatchImage2x } 2x` }
            alt="精子提供の方法"
          />
        </div>
      </header>
      <main className="sub">
        <section className="way">
          <h1 className="sec_title">精子提供の方法</h1>
          <h2 className="main_title"><span>精子提供の方法は２つ</span></h2>
          <ul className="text_list">
            <li>
              <h3 className="sub_title">シリンジ法</h3>
              <p>シリンジ法とは、先端がシリコンでできた注射器を使用し、精子をスポイトのように吸い上げて膣内に注入する方法です。</p>
              <p>男性との性行為に抵抗のある場合はこの方法を採用しましょう。</p>
              <p>男性が射精するための清潔な空間や女性が注入するための個室空間を確保できる場所、例えばホテルのロビーなどが待ち合わせ場所に選ばれることが多いようです。</p>
              <p>シリンジ法キットはインターネットで購入可能ですので、事前に準備しておきましょう。</p>
              <div className="kit_cards">
                <div className="kit_card">
                  <img
                    src="//thumbnail.image.rakuten.co.jp/@0_mall/babylife-lab/cabinet/shohin/meeta10plus1-240425.jpg"
                    alt="おすすめシリンジキット"
                    className="kit_card_img"
                  />
                  <div className="kit_card_body">
                    <p className="kit_card_name">おすすめシリンジキット</p>
                    <p className="kit_card_desc">Ton Bébéおすすめのシリンジ法キットです。</p>
                    <div className="kit_card_btnarea">
                      <a
                        href="//af.moshimo.com/af/c/click?a_id=1784748&p_id=54&pc_id=54&pl_id=616&url=https%3A%2F%2Fitem.rakuten.co.jp%2Fbabylife-lab%2Fmeeta-202010%2F&m=http%3A%2F%2Fm.rakuten.co.jp%2Fbabylife-lab%2Fi%2F10000038%2F"
                        rel="nofollow"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="kit_shop_btn rakuten"
                      >楽天市場で購入</a>
                      <a
                        href="//af.moshimo.com/af/c/click?a_id=1784765&p_id=170&pc_id=185&pl_id=4062&url=https%3A%2F%2Fwww.amazon.co.jp%2Fdp%2FB08KSY5P14"
                        rel="nofollow"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="kit_shop_btn amazon"
                      >Amazonで購入</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <h3 className="sub_title">タイミング法</h3>
              <p>タイミング法とは、排卵のタイミングに合わせて自然な性行為により精子提供を行う方法です。</p>
              <p>シリンジ法に比べてより新鮮な精子を提供できますが、相互にパートナーがいる場合、より深い理解が必要とされる方法です。条件をしっかり合意のうえ、採用しましょう。</p>
            </li>
          </ul>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default MethodPage;
